import api from "../api";

const pageSize = 10;
const products = {
  // TODO tell backend dev to make this route return all products
  get() {
    return new Promise((resolve, reject) => {
      api.get(
        `/products/?page=1&pageSize=${pageSize}`,
        data => resolve(data),
        error => reject(error)
      );
    });
  },
  getByPage(page) {
    return new Promise((resolve, reject) => {
      api.get(
        `/products/?page=${page}&pageSize=${pageSize}`,
        data => resolve(data),
        error => reject(error)
      );
    });
  },

  getProductById(productId) {
    return new Promise((resolve, reject) => {
      api.get(
        `products/${productId}`,
        data => resolve(data),
        error => reject(error)
      );
    });
  },

  getCategories() {
    return new Promise((resolve, reject) => {
      api.get(
        "/product-categories/",
        data => resolve(data),
        error => reject(error)
      );
    });
  },
};

export default products;
